import { constant } from "../../constants";
import { StorageConstants } from "../../constants/StorageConstants";

export const getIdToken = () => {
  return localStorage.getItem(StorageConstants.JWTToken);
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};
export const getAccessToken = () => {
  return localStorage.getItem(StorageConstants.AccessToken);
};

export const getExpiresIn = () => {
  return localStorage.getItem("expiresIn");
};

export const setIdToken = (value: string) => {
  return localStorage.setItem(StorageConstants.JWTToken, value);
};

export const clearStorage = () => {
  localStorage.clear();
};

export const redirectToRefreshToken = () => {
  window.location.href = `/${constant.domain}/tokenRefreshError`;
};
